import React, { Component } from 'react';
import { Table, ButtonToolbar, Grid, Row, Col } from 'react-bootstrap';

import { DownloadCommand } from '../commands/DownloadCommand';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { TableButton } from '../../TableButton';

export class LayoutsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    onDownloadLayout(layout) {
        const downloadCommand = new DownloadCommand();
        downloadCommand.downloadLayout(
            layout,
            (a, b) => this.saveAs(a, b),
            (a) => this.errorCallback(a)
        );
    }

    saveAs(blob, fileName) {
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, fileName);
    }

    errorCallback(errorMessage) {
        this.setState({
            message: {
                show: true,
                message: errorMessage,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        });
    }

    // -----------------------

    render() {
        const { isLoading } = this.props;
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        const { data, filter, page, elementsPerPage } = this.props.table;
        const { message } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: filter,
            data: data,
            fields: ["name", "format", "orientation"]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, elementsPerPage);
        const activePage = totalPages < page ? totalPages : page;
        const partialData = dataFiltered.slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <Table responsive striped hover className="margin-top-10">
                            <thead>
                                <tr>
                                    <th className="width-60p">Nome</th>
                                    <th className="width-20p">Formato</th>
                                    <th className="width-20p">Orientação</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    partialData.map((layout, idx) =>
                                        <tr key={`layout-${idx}`}>
                                            <td>{layout.name}</td>
                                            <td>{layout.format}</td>
                                            <td>{layout.orientation}</td>
                                            <td>
                                                <ButtonToolbar style={{ display: "flex" }}>
                                                    <TableButton marginRight icon="icon-download" title="Download" onClick={() => this.onDownloadLayout(layout)} />
                                                    <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditLayout(layout)} />
                                                    <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteLayout(layout)} />
                                                </ButtonToolbar>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>

                        <PaginationBuilder
                            currentPage={page}
                            elementsPerPage={elementsPerPage}
                            dataLength={dataFiltered.length}
                            onChangePage={this.props.onChangePage}
                            onChangeElementsPerPage={this.props.onChangeElementsPerPage} />

                        <HandleMessage
                            title={message.title}
                            message={message.message}
                            style={message.style}
                            icon={message.icon}
                            show={message.show}
                            onHide={() => this.onExitMessage()} />
                    </Col>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/LayoutsTable.js